<template>
    <div class="brand-pin-target">
        <CommonComponentsSVGCommonBlueDownArrow class="solution-arrow-down" />
        <div class="brand-panoramagram-container global-limited-1360px-container">
            <!-- <CommonComponentsUnionTitleWithNumber v-if="false" :union-title="data" class="num" /> -->
            <div class="brand-panoramagram-gsap">
                <div class="chainImg">
                    <div class="chainImg-title">{{ $t('global_solutions_brand_chainImg_title') }}</div>
                    <img :src="isCN ? chain : chainEN" alt="" />
                </div>
                <!-- <CommonComponentsSVGSolutionsCircleEn v-else class="png" /> -->
            </div>
        </div>
        <CommonComponentsFooter />
    </div>
</template>

<script setup lang="ts">
    import panoramagram from '@assets/imgs/Solutions/Manufacturer/Swipper/panoramagram.png';
    import chain from '@assets/imgs/Solutions/Brand/Swipper/chain.png';
    import chainEN from '@assets/imgs/Solutions/Brand/Swipper/chainEN.png';

    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();
    gsap.registerPlugin(ScrollTrigger);

    const data = {
        title: 'global_solutions_brand_panoramagram_title_1',
        subTitle: 'global_solutions_brand_panoramagram_subtitle_1',
        panoramagram,
    };

    onMounted(() => {});
</script>

<style lang="less" scoped>
    .brand-pin-target {
        display: flex;
        flex-direction: column;
        align-items: center;
        .solution-arrow-down {
            margin: .convert(100px) [ @vw] 0;
            height: .convert(194px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                margin: 40px 0;
                height: 50px;
            }
        }

        .brand-panoramagram-container {
            margin-top: .convert(20px-16px) [ @vw]; //title有16px 一共60 40+20
            display: flex;
            flex-direction: column;
            @media (max-width: @screen-mobile-width) {
                justify-content: center;
                margin-top: 0; //title有16px 一共60 40+20
            }
            .num {
                margin-top: 45px;
                // z-index: 2;
                width: 55%;
                margin: 0 auto;
                @media (max-width: @screen-mobile-width) {
                    margin-top: 0px;
                    width: 100%;
                    margin: 0 auto;
                }
                :deep(.union-subtitle) {
                    margin-top: .convert(20px) [ @vw];
                }
            }
            .brand-panoramagram-gsap {
                display: flex;
                justify-content: center;
                // height: 90vh;
                @media (max-width: @screen-mobile-width) {
                    // height: .convert(1660px) [ @vw];
                }

                .chainImg {
                    margin-bottom: .convert(139px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        margin-bottom: .convert(61px) [ @vw-mobile];
                    }
                    img {
                        width: 100%;
                    }
                    &-title {
                        text-align: center;
                        font-family: 'HarmonyOS Sans SC';
                        font-size: .convert(48px) [ @vw];
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        margin-bottom: .convert(20px) [ @vw];
                        @media (max-width: @screen-mobile-width) {
                            font-size: .convert(16px) [ @vw-mobile];
                            margin-bottom: .convert(12px) [ @vw-mobile];
                        }
                    }
                }

                .png {
                    height: 105vh;
                    @media (max-width: @screen-mobile-width) {
                        height: 100%;
                        width: 100%;
                        transform: scale(1.1);
                    }
                }
            }
        }
    }
</style>
